var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCreateMobile(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "#fff",
    opacity: 0
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.059 -0.178)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.2,11.4a9.657,9.657,0,0,1,7.2-7.2,17.168,17.168,0,0,1,7.841,0,9.657,9.657,0,0,1,7.2,7.2,17.169,17.169,0,0,1,0,7.841,9.657,9.657,0,0,1-7.2,7.2,17.169,17.169,0,0,1-7.841,0,9.657,9.657,0,0,1-7.2-7.2A17.168,17.168,0,0,1,4.2,11.4Z",
    transform: "translate(0 0)",
    fill: "rgba(27,204,150,0.05)",
    stroke: "#1bcc96",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.285,15.142H10m5.142,5.142V10",
    transform: "translate(0.178 0.178)",
    fill: "none",
    stroke: "#1bcc96",
    strokeLinecap: "round",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateMobile);
export default __webpack_public_path__ + "static/media/createMobile.74214ab8d17427be75fea99df240e140.svg";
export { ForwardRef as ReactComponent };